import { render } from "./SmsBuyCredits.vue?vue&type=template&id=ad3965ee&scoped=true"
import script from "./SmsBuyCredits.vue?vue&type=script&lang=js"
export * from "./SmsBuyCredits.vue?vue&type=script&lang=js"

import "./SmsBuyCredits.vue?vue&type=style&index=0&id=ad3965ee&scoped=true&lang=css"

import exportComponent from "/Users/abayomi/IdeaProjects/microservice-2/harvest-app-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad3965ee"]])

export default __exports__